import type { SelfProjectDto } from "@/api/types";

import { useSessionUser } from "./useSessionUser";

export function useProject(): SelfProjectDto {
  return useSessionUser().project;
}
